// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
   min-width: 600px;
   max-height: 400px;
   min-height: 400px;
   display: flex;
   flex: 1;
   overflow: hidden;
}

@media only screen and (min-width: 1024px) {
   .main {
      min-width: 800px;
   }
}

@media only screen and (min-width: 1440px) {
   .main {
      min-width: 950px;
   }
}

app-form-list {
   display: flex;
   flex: 1;
   overflow: hidden;
}

.visible { opacity: 1 }
::ng-deep .mat-button:hover .mat-button-focus-overlay{
   opacity: 0.04 !important;
}

/* disabled this because after close dialog this style still working */
/* ::ng-deep body {
   overflow: hidden !important;
} */

.fixed-toolbar {
   align-items: center;
   background-color: #fff;
   border-bottom: 1px solid #eaeaea;
   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.05);
   position: fixed;
   left: 240px;
   right: 0;
   padding-left: 20px;
   z-index: 5;
   height: 50px;
}

.breadcrumb-container {
   margin-right: 10px;
   max-height: 100%;
}

.toolbar {
   align-items: center;
   padding-right: 20px;
}

.fixed-toolbar ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

.example-container {
   display: flex;
   flex-direction: column;
}

.example-container > * {
   width: 25%;
}

.menu > li {
   float: left;
}

.menu > li + li {
   margin-left: 1em;
}

.menu > li > a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu > li > a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open > a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu > li > a > i {
   font-size: 16px;
   margin-right: 10px;
}

.menu button {
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.menu button i {
   font-size: 16px;
   margin-right: 10px;
}

#btn-del-form {
   margin-right: 10px;
}

.div-header {
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: flex-end;
   min-height: 64px;
}

.mat-form-field {
   width: 200px;
   justify-content: flex-start;
   margin-right: 30px;
   font-size: 14px;
}

.div-container {
   display: flex;
   flex-direction: column;
   /*max-height: 310px;*/
   min-width: 300px;
   position: relative;
}

.actions {
   display: flex;
   justify-content: flex-end;
}

.mat-column-select {
   overflow: visible;
}

::ng-deep mat-cell, mat-footer-cell, mat-header-cell {
   flex: 1;
   display: unset !important;
   align-items: center;
   overflow: hidden;
   word-wrap: break-word;
   min-height: unset !important;
}

.col-menu {
   flex: 0 0 5% !important;
}

.fixed-toolbar {
   align-items: center;
   background-color: #fff;
   border-bottom: 1px solid #eaeaea;
   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);
   position: fixed;
   left: 240px;
   top: 50px;
   height: 50px;
   right: 0;
   padding: 0 20px;
   z-index: 5;
}

.fixed-toolbar ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

.breadcrumb-container {
   margin-right: 10px;
   max-height: 100%;
}

.breadcrumb-container h1 {
   font-size: 18px;
   font-weight: normal;
   margin: 0;
}

.flex-container {
   display: flex;
   flex-direction: row;
}
.mat-form-field {
   width: 700px;
}

.fitter {
   flex-grow: 7;
   padding-left: 24px;
}

.form-list {
   margin: 0 10px 10px;
   width: 98%;
   transition: background-color .3s, opacity .3s;

   display: flex;
   flex-direction: column;
   flex: 1;
   overflow-x: hidden;
   overflow-y: auto;
   position: relative;
}

.paginator{
   float: right;
}

td.mat-cell{
   white-space: nowrap;
   text-overflow: ellipsis;
   max-width: 200px;
   overflow: hidden;
}

.empty-folder {
   flex-direction: column;
   margin-right: 2em;
   text-align: center;
}

.empty-folder img {
   width: 150px;
   height: 150px;
   opacity: .6;
   filter: grayscale(10%);
}

.empty-folder h4 {
   font-size: 20px;
   margin: 0 0 10px;
}

.mat-table tr.mat-header-row {
   height: 45px;
}
th.mat-header-cell .mat-sort-header-container.mat-sort-header-sorted .mat-sort-header-arrow {
   opacity: 1 !important;
   transform: translateY(0) !important;
}

`, "",{"version":3,"sources":["webpack://./src/app/admin/pdf-template-list-dialog/pdf-template-list-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,iBAAiB;GACjB,aAAa;GACb,OAAO;GACP,gBAAgB;AACnB;;AAEA;GACG;MACG,gBAAgB;GACnB;AACH;;AAEA;GACG;MACG,gBAAgB;GACnB;AACH;;AAEA;GACG,aAAa;GACb,OAAO;GACP,gBAAgB;AACnB;;AAEA,WAAW,WAAW;AACtB;GACG,wBAAwB;AAC3B;;AAEA,sEAAsE;AACtE;;GAEG;;AAEH;GACG,mBAAmB;GACnB,sBAAsB;GACtB,gCAAgC;GAChC,8CAA8C;GAC9C,eAAe;GACf,WAAW;GACX,QAAQ;GACR,kBAAkB;GAClB,UAAU;GACV,YAAY;AACf;;AAEA;GACG,kBAAkB;GAClB,gBAAgB;AACnB;;AAEA;GACG,mBAAmB;GACnB,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,mBAAmB;GACnB,yBAAyB;GACzB,gBAAgB;AACnB;;AAEA;GACG,YAAY;GACZ,2BAA2B;GAC3B,kBAAkB;GAClB,eAAe;AAClB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,qBAAqB;GACrB,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,yBAAyB;AAC5B;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,OAAO;GACP,yBAAyB;GACzB,mBAAmB;GACnB,gBAAgB;GAChB,qBAAqB;GACrB,4BAA4B;AAC/B;;AAEA;GACG,uBAAuB;AAC1B;;AAEA;GACG,mBAAmB;GACnB,sBAAsB;GACtB,gCAAgC;GAChC,6CAA6C;GAC7C,eAAe;GACf,WAAW;GACX,SAAS;GACT,YAAY;GACZ,QAAQ;GACR,eAAe;GACf,UAAU;AACb;;AAEA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,kBAAkB;GAClB,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,mBAAmB;GACnB,SAAS;AACZ;;AAEA;GACG,aAAa;GACb,mBAAmB;AACtB;AACA;GACG,YAAY;AACf;;AAEA;GACG,YAAY;GACZ,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;GACnB,UAAU;GACV,6CAA6C;;GAE7C,aAAa;GACb,sBAAsB;GACtB,OAAO;GACP,kBAAkB;GAClB,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,mBAAmB;GACnB,uBAAuB;GACvB,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA;GACG,sBAAsB;GACtB,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,aAAa;GACb,WAAW;GACX,sBAAsB;AACzB;;AAEA;GACG,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,YAAY;AACf;AACA;GACG,qBAAqB;GACrB,mCAAmC;AACtC","sourcesContent":[".main {\n   min-width: 600px;\n   max-height: 400px;\n   min-height: 400px;\n   display: flex;\n   flex: 1;\n   overflow: hidden;\n}\n\n@media only screen and (min-width: 1024px) {\n   .main {\n      min-width: 800px;\n   }\n}\n\n@media only screen and (min-width: 1440px) {\n   .main {\n      min-width: 950px;\n   }\n}\n\napp-form-list {\n   display: flex;\n   flex: 1;\n   overflow: hidden;\n}\n\n.visible { opacity: 1 }\n::ng-deep .mat-button:hover .mat-button-focus-overlay{\n   opacity: 0.04 !important;\n}\n\n/* disabled this because after close dialog this style still working */\n/* ::ng-deep body {\n   overflow: hidden !important;\n} */\n\n.fixed-toolbar {\n   align-items: center;\n   background-color: #fff;\n   border-bottom: 1px solid #eaeaea;\n   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n   position: fixed;\n   left: 240px;\n   right: 0;\n   padding-left: 20px;\n   z-index: 5;\n   height: 50px;\n}\n\n.breadcrumb-container {\n   margin-right: 10px;\n   max-height: 100%;\n}\n\n.toolbar {\n   align-items: center;\n   padding-right: 20px;\n}\n\n.fixed-toolbar ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.example-container {\n   display: flex;\n   flex-direction: column;\n}\n\n.example-container > * {\n   width: 25%;\n}\n\n.menu > li {\n   float: left;\n}\n\n.menu > li + li {\n   margin-left: 1em;\n}\n\n.menu > li > a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open > a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu > li > a > i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n#btn-del-form {\n   margin-right: 10px;\n}\n\n.div-header {\n   display: flex;\n   flex-direction: row;\n   align-items: center;\n   justify-content: flex-end;\n   min-height: 64px;\n}\n\n.mat-form-field {\n   width: 200px;\n   justify-content: flex-start;\n   margin-right: 30px;\n   font-size: 14px;\n}\n\n.div-container {\n   display: flex;\n   flex-direction: column;\n   /*max-height: 310px;*/\n   min-width: 300px;\n   position: relative;\n}\n\n.actions {\n   display: flex;\n   justify-content: flex-end;\n}\n\n.mat-column-select {\n   overflow: visible;\n}\n\n::ng-deep mat-cell, mat-footer-cell, mat-header-cell {\n   flex: 1;\n   display: unset !important;\n   align-items: center;\n   overflow: hidden;\n   word-wrap: break-word;\n   min-height: unset !important;\n}\n\n.col-menu {\n   flex: 0 0 5% !important;\n}\n\n.fixed-toolbar {\n   align-items: center;\n   background-color: #fff;\n   border-bottom: 1px solid #eaeaea;\n   box-shadow: 0 4px 6px -2px rgba(0, 0, 0, .05);\n   position: fixed;\n   left: 240px;\n   top: 50px;\n   height: 50px;\n   right: 0;\n   padding: 0 20px;\n   z-index: 5;\n}\n\n.fixed-toolbar ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.breadcrumb-container {\n   margin-right: 10px;\n   max-height: 100%;\n}\n\n.breadcrumb-container h1 {\n   font-size: 18px;\n   font-weight: normal;\n   margin: 0;\n}\n\n.flex-container {\n   display: flex;\n   flex-direction: row;\n}\n.mat-form-field {\n   width: 700px;\n}\n\n.fitter {\n   flex-grow: 7;\n   padding-left: 24px;\n}\n\n.form-list {\n   margin: 0 10px 10px;\n   width: 98%;\n   transition: background-color .3s, opacity .3s;\n\n   display: flex;\n   flex-direction: column;\n   flex: 1;\n   overflow-x: hidden;\n   overflow-y: auto;\n   position: relative;\n}\n\n.paginator{\n   float: right;\n}\n\ntd.mat-cell{\n   white-space: nowrap;\n   text-overflow: ellipsis;\n   max-width: 200px;\n   overflow: hidden;\n}\n\n.empty-folder {\n   flex-direction: column;\n   margin-right: 2em;\n   text-align: center;\n}\n\n.empty-folder img {\n   width: 150px;\n   height: 150px;\n   opacity: .6;\n   filter: grayscale(10%);\n}\n\n.empty-folder h4 {\n   font-size: 20px;\n   margin: 0 0 10px;\n}\n\n.mat-table tr.mat-header-row {\n   height: 45px;\n}\nth.mat-header-cell .mat-sort-header-container.mat-sort-header-sorted .mat-sort-header-arrow {\n   opacity: 1 !important;\n   transform: translateY(0) !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
